// extracted by mini-css-extract-plugin
export default {"container":"DotWrapper_container__chLBn","dot":"DotWrapper_dot__Iysln","green":"DotWrapper_green__a8FVk","orange":"DotWrapper_orange__9YpoT"};